module.exports = __webpack_public_path__ + "img/title-bg.ed30ed4e.png";